import { helper } from "@ember/component/helper";
import dayjs from "dayjs";
import type {} from "dayjs/plugin/relativeTime";

type Positional = [date: dayjs.ConfigType];

export interface Signature {
  Args: {
    Positional: Positional;
  };
  Return: string;
}

const dayjsFromNow = helper<Signature>(([date]: Positional) => {
  return dayjs(date).fromNow();
});

export default dayjsFromNow;
